import React, {useEffect} from 'react';
import ProjectsIntro from "../components/projectsIntro";
import GoTop from "../components/GoTop";

const Projects = () => {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({top: 0, left: 0, behavior: 'auto'});
  }, []);
  return (
    <section id="projects">
      <div className="only">
        <ProjectsIntro />
        <GoTop />
      </div>
    </section>
  );
};

export default Projects;
